import { render, staticRenderFns } from "./WXCW81SXXBJ.vue?vue&type=template&id=13c2b7f0&scoped=true&"
import script from "./WXCW81SXXBJ.vue?vue&type=script&lang=js&"
export * from "./WXCW81SXXBJ.vue?vue&type=script&lang=js&"
import style0 from "./WXCW81SXXBJ.vue?vue&type=style&index=0&id=13c2b7f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c2b7f0",
  null
  
)

export default component.exports